import { LayoutTemplate } from "../../components/templates/Layout"

export function Component() {
  return <LayoutTemplate />
}
